import {Component, input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {PlanningRegion} from "../../../../models/planning_region.model";
import {Screen} from "../../../../models/screen.model";
import {dateUtils} from "../../../../helpers/date.utils";
import {NgbDateStruct, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
  ScreenCommentModalComponent
} from "../../../../shared/modals/planning-region/planning-region-screen-comment-modal/planning-region-screen-comment-modal.component";

@Component({
  selector: '[app-planning-region-header]',
  standalone: true,
    imports: [
        TranslateModule
    ],
  templateUrl: './planning-region-header.component.html',
  styleUrl: './planning-region-header.component.scss'
})
export class PlanningRegionHeaderComponent {
  screen = input.required<Screen>()
  dateValue = input.required<NgbDateStruct>()
  data = input.required<PlanningRegion>()

  constructor(private modalService: NgbModal) {
  }

  hasComments(): boolean {
    const wedn = dateUtils.formatDateStruct(dateUtils.toDate(this.dateValue()));
    const existingComment = this.data().screen_comment?.[wedn]?.[this.screen().screen_id] || [];
    return existingComment && existingComment.length > 0;
  }

  openCommentModal(): void {
    const wedn = dateUtils.formatDateStruct(dateUtils.toDate(this.dateValue()))
    const existingComment = this.data().screen_comment?.[wedn]?.[this.screen().screen_id] || [];
    const modalRef = this.modalService.open(ScreenCommentModalComponent,
      {
        size: 'lg',
        centered: true,
      });
    modalRef.componentInstance.comments = existingComment;
    modalRef.componentInstance.screenId = this.screen().screen_id;
    modalRef.componentInstance.liv_ville = this.screen().ville;
    modalRef.componentInstance.nom_cinema = this.screen().nom_cinema;
    modalRef.componentInstance.date = this.dateValue();
  }
}
